//react...
import React from "react";

//styles...
import './Logo.styles.css'

//Logo...
import logo from '../../assets/logo/logo.png';




const Logo=()=>{

    return(
            <img src={logo}  alt="logo" className="footer-logo d-inline-block"/>
    )
}

export default Logo